export const setIsDirty = (isDirty = false) => {
	return {
		type: "isDirty/set",
		payload: isDirty,
	};
}
